import React from 'react';

const ShopHeader: React.FC = () => {
  return (
    <h1 className="fw-bold text-center font-fraunces text-primary-custom shop-heading">
      <span className="text-dark-custom">Shop to</span> Support
    </h1>
  );
};

export default ShopHeader;
